/**
 * **UNA live region sola per tutta l'app** (revisione sfide-orcr 28/9 18:12Z): la carta-sfida nel DM
 * non porta piu' `role="status"` su ogni riga storica — con una cronologia di piu' inviti vecchi,
 * N live region contemporanee si annuncerebbero tutte insieme al primo render. Il cambio di stato
 * che segue un TOCCO (es. Accetta che scopre un 404 e toglie i pulsanti) resta pero' degno di essere
 * annunciato: lo fa questa, imperativamente, su un nodo unico e condiviso.
 *
 * Non e' un componente: un `<div>` visivamente nascosto, creato una volta sola e riusato. Un
 * componente React lo monterebbe/smonterebbe con l'albero di chi lo chiama, e la prima cosa che uno
 * screen reader deve trovare per annunciare un `aria-live="polite"` e' che il nodo ESISTA gia'
 * quando il testo cambia — nascerlo insieme al testo non annuncia niente.
 */
let nodo: HTMLElement | null = null;

function nodoAnnuncio(): HTMLElement | null {
  if (typeof document === 'undefined') return null;
  if (nodo && document.body.contains(nodo)) return nodo;
  const el = document.createElement('div');
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  el.setAttribute('aria-atomic', 'true');
  el.style.position = 'absolute';
  el.style.width = '1px';
  el.style.height = '1px';
  el.style.overflow = 'hidden';
  el.style.clipPath = 'inset(50%)';
  el.style.whiteSpace = 'nowrap';
  document.body.appendChild(el);
  nodo = el;
  return el;
}

/**
 * Annuncia `testo` allo screen reader. Sicura anche fuori da un DOM (SSR/test senza `document`): non
 * fa niente. Lo stesso testo due volte di fila si rifà sentire (uno spazio invisibile in coda rompe
 * l'uguaglianza senza cambiare cio' che si legge) — alcuni screen reader non riannunciano un
 * `textContent` identico.
 */
export function annuncia(testo: string): void {
  const el = nodoAnnuncio();
  if (el === null) return;
  el.textContent = el.textContent === testo ? `${testo}\u00a0` : testo;
}
